"use client"

import { useState, useEffect } from "react"
import "./OverviewSection.css"
import ProductIdeationCard from "../components/ProductIdeationCard"

// Card content arrays - ADD route property to each card object
const ideationCards = [
  {
    title: "Scoping Session",
    desc: "Build a solid roadmap to make your vision real and plan ahead for your product development.",
    route: "/services/scoping-session",
  },
  {
    title: "Product Design Process",
    desc: "A collection of matured techniques to build meaningful and user-driven interfaces.",
    route: "/services/product-design",
  },
  {
    title: "Digital Transformation",
    desc: "A seamless transformation approach with a smooth transition to the digital realm.",
    route: "/services/digital-transformation",
  },
  {
    title: "Minimum Viable Product",
    desc: "Identify the core functionalities of your business idea and build an MVP to validate it.",
    route: "/services/minimum-viable",
  },
]

const productDevelopment = [
  {
    title: "Software Development",
    desc: "Build high-quality and technical debt-free software following the Agile Development Process.",
    route: "/services/software-development",
  },
  {
    title: "Web Development",
    desc: "Build user-centric websites, web solutions, and custom web applications and scale your online presence.",
    route: "/services/web-development",
  },
  {
    title: "MOBILE DEVELOPMENT",
    desc: "Build a strong brand with mobile apps adjusted to your market needs and user experience.",
    route: "/services/mobile-development",
  },
  {
    title: "NEARSHORE TEAMS",
    desc: "A hassle-free project setup, with teams that help you hit the ground confidently and efficiently.",
    route: "/services/nearshore-teams",
  },
  {
    title: "DATA SCIENCE",
    desc: "Architect, build, and scale custom Data Science solutions for your business.",
    route: "/services/ai-ds",
  },
  {
    title: "UX/UI DESIGN",
    desc: "Design your product from top to bottom and skyrocket its usability, efficiency, and users' needs.",
    route: "/services/ui-ux",
  },
  {
    title: "QUALITY ASSURANCE",
    desc: "Ensure an error-free software development by focusing on prevention rather than just detection.",
    route: "/services/qa",
  },
]

const productImprovement = [
  {
    title: "DIGITAL-ACCELERATION",
    desc: "Helping you swiftly embrace digital acceleration and achieve remarkable growth.",
    route: "/services/didgital-acceleration",
  },
  {
    title: "CODE AUDIT",
    desc: "Our code review process ensures a fine-tuned product from its very core.",
    route: "/services/code-audit",
  },
  {
    title: "UX AUDIT",
    desc: "We conduct a UX Audit to identify issues and provide detailed recommendations to optimize it.",
    route: "/services/ux-audit",
  },
]

const FeatureSection = () => {
  const [active, setActive] = useState("overview")

  const handleClick = (id) => {
    setActive(id)
    const section = document.getElementById(id)
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" })
    }
  }

  useEffect(() => {
    const handleScroll = () => {
      const sections = ["overview", "team", "working-model", "industries", "tech-stack", "case-studies"]
      const scrollPosition = window.scrollY + 200 // Offset for navbar height

      for (let i = sections.length - 1; i >= 0; i--) {
        const section = document.getElementById(sections[i])
        if (section && section.offsetTop <= scrollPosition) {
          setActive(sections[i])
          break
        }
      }
    }

    window.addEventListener("scroll", handleScroll)
    handleScroll() // Call once to set initial state

    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  return (
    <>
      {/* Sticky Navbar */}
      <div className="feature-navbar37561">
        <div className="container">
          <ul>
            <li>
              <a onClick={() => handleClick("overview")} className={active === "overview" ? "active" : ""}>
                OVERVIEW
              </a>
            </li>
            <li>
              <a onClick={() => handleClick("team")} className={active === "team" ? "active" : ""}>
                TEAM
              </a>
            </li>
            <li>
              <a onClick={() => handleClick("working-model")} className={active === "working-model" ? "active" : ""}>
                WORKING MODEL
              </a>
            </li>
            <li>
              <a onClick={() => handleClick("industries")} className={active === "industries" ? "active" : ""}>
                INDUSTRIES
              </a>
            </li>
            <li>
              <a onClick={() => handleClick("tech-stack")} className={active === "tech-stack" ? "active" : ""}>
                TECH-STACK
              </a>
            </li>
            <li>
              <a onClick={() => handleClick("case-studies")} className={active === "case-studies" ? "active" : ""}>
                CASE STUDIES
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* Overview Section */}
      <section className="feature-section37561" id="overview">
        <div className="container">
          <div className="feature-content37561">
            <p>
              We offer custom development that follows fast, reliable, and technical debt-free processes to ensure
              companies can scale without technology getting in the way.
              <br />
              <b>‍That is what we call seamless technology.</b>
            </p>
          </div>

          {/* Cards - REMOVE routes prop, routes are now in card objects */}
          <div className="feature-card-wrapper37561">
            <ProductIdeationCard title="PRODUCT IDEATION" cards={ideationCards} />
            <ProductIdeationCard title="PRODUCT DEVELOPMENT" cards={productDevelopment} />
            <ProductIdeationCard title="PRODUCT IMPROVEMENT" cards={productImprovement} />
          </div>
        </div>
      </section>
    </>
  )
}

export default FeatureSection
